<template>
    <div class = "my_from">
        <DxForm :form-data="formData">

            <DxSimpleItem>
                <DxLabel text="公众号" />
                <template #default>
                    <div>
                        <DxSelectBox @value-changed="changeWechatBox" :data-source="wechatSelect" display-expr="appName" value-expr="id"  value-change-event="keyup"></DxSelectBox>
                    </div>
                </template>
            </DxSimpleItem>

            <DxGroupItem :col-span="3">
                <DxSimpleItem data-field="UID">
                    <DxLabel text="接收消息的用户UID,多个UID用英文状态的,分隔" />
                </DxSimpleItem>

                <DxSimpleItem>
                    <DxLabel text="模板" />
                    <template #default>
                        <div>
                            <DxSelectBox @value-changed="changeModeltBox" :data-source="modeSelect" display-expr="title" value-expr="template_id"  value-change-event="keyup"></DxSelectBox>
                        </div>
                    </template>
                </DxSimpleItem>

                <DxSimpleItem>
                    <DxLabel text="接收消息的某个标签,多个TID用英文状态的,分隔" />
                    <template #default>
                        <div>
                            <DxSelectBox @value-changed="changeTagsBox" :data-source="positionOptions"  display-expr="name" value-expr="id"   value-change-event="keyup"></DxSelectBox>
                        </div>
                    </template>
                </DxSimpleItem>
<!--                <DxSimpleItem data-field="TagsID"/>-->
                <DxSimpleItem data-field="sendTime" editor-type="dxDateBox" :editor-options="{type: 'datetime', displayFormat: 'yyyy-MM-dd HH:mm:ss'}">
                    <DxLabel text="发送时间" />
                </DxSimpleItem>
            </DxGroupItem>

        </DxForm>
        <!--发送内容，根据模板id查找map-->
        <div>
            <div class="content-text">发送内容</div>
            <DxForm :form-data="formData2" v-show="showContent"  :col-count="2">
                <DxGroupItem v-for="(item,index) in itemMap" :key="index" >
                    <DxSimpleItem :data-field="item.itemValue">
                        <DxLabel :text="item.itemName" />
                    </DxSimpleItem>

                </DxGroupItem>
            </DxForm>
        </div>


        <DxButton @click="submitFrom" class="my_submit">发送</DxButton>
    </div>

</template>

<script>
    import '../../../css/my_styles.css';

    export default {
        name: "tasksMessage",
        data(){
            return{
                birthDateOptions: { width: '100%' },
                formData: {},
                formData2: {},
                positionOptions: [],
                loading: false,
                showContent:false,
                wechatSelect:[],
                modeSelect:[ ],
                itemMap:[]
            }
        },
        created() {
            this.$http.get_wxconfig(null).then(res =>{
                this.wechatSelect = res.data
            })
        },
        methods:{
            changeWechatBox(e){
                this.formData.wechatId = e.value
                //根据微信公众号获取所有的模板
                this.$http.get_template_all({"appId":e.value}).then(res =>{
                    this.modeSelect =res.data
                })
                //获取公众号用户标签
                this.$http.get_all_tags_pu({"appId":e.value}).then( res=>{
                    this.positionOptions = res.data
                })
            },
            submitFrom: async function(){
                //console.log(this.formData)
                this.loading = true;
                this.formData.sendConnet = this.formData2
                this.formData.uidStr = JSON.stringify([this.formData.UID])

                //提交信息
                this.$http.send_message_public(this.formData).then(res =>{
                    //console.log(res)
                })

                //重置表单
                this.formData = []
                this.formData2 = []
                this.loading = true;

                //提交信息
                //重置表单
                // this.formData.reset()
                // this.formData2.reset()

            },
            changeModeltBox(e){
                this.itemMap = []
                this.formData.modeId = e.value
                const tmep = this.modeSelect.filter(item => item.template_id == e.value)

                for(let key in tmep[0].content){
                    let temp={
                        "itemValue":tmep[0].content[key],
                        "itemName" : key
                    }
                    this.itemMap.push(temp)
                }
                this.showContent = true
            },
            changeTagsBox(e){
                this.formData.tidStr=JSON.stringify([e.value])
            },

        }
    }
</script>

<style scoped>
    .content-text{
        padding: 20px 0;
        color: #4cae4c;
        font-size: 18px;
    }

</style>